module.exports = __webpack_public_path__ + "fonts/HelveticaNowMicro-RegIta.6935bd48.woff2";